import { useEffect, useMemo, useState } from "react";

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/shared/ui/alert-dialog.tsx";
import {
  useNotifications,
  useReadNotification,
} from "@/entities/notification/api";
import { PAGE_SIZE } from "@/shared/lib/consts.ts";
import type { Notification } from "@/entities/notification/model";

export const NotificationLayout = () => {
  const { data } = useNotifications({
    pageSize: PAGE_SIZE,
    currentPage: 1,
    isArchived: false,
  });

  const [isOpen, setIsOpen] = useState(false);

  let latestBannerNotification = useMemo(() => {
    if (data?.data) {
      return data.data.find(
        (notif: Notification) =>
          notif.notification.type === "Банер" && !notif.isArchived,
      );
    }
    return null;
  }, [data]);

  const { mutateAsync } = useReadNotification();

  const handleReadNotification = async (id: string) => {
    try {
      await mutateAsync({ id }).then(() => {
        latestBannerNotification = {};
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (latestBannerNotification?.notification) {
      setIsOpen(true);
    }
  }, [latestBannerNotification]);

  if (!latestBannerNotification) return null;

  return (
    <AlertDialog open={isOpen} onOpenChange={(isOpen) => setIsOpen(isOpen)}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-xl font-semibold text-textColor">
            Важное объявление
          </AlertDialogTitle>
        </AlertDialogHeader>
        <span className="text-textColor">
          {latestBannerNotification.notification.text}
        </span>
        <AlertDialogCancel
          onClick={() => {
            handleReadNotification(latestBannerNotification._id);
            setIsOpen(false);
          }}
          className="text-textColor"
        >
          Закрыть
        </AlertDialogCancel>
      </AlertDialogContent>
    </AlertDialog>
  );
};
